if (!customElements.get('products-tabs-grid')) {
    class ProductsTabsGrid extends HTMLElement {
        constructor() {
            super();

            this.tabs = Array.from(this.querySelectorAll('.products-tabs-grid__tab'));
            this.items = Array.from(this.querySelectorAll('[data-item]'));
            this.grid = this.querySelector('[data-grid]');

            this.sortToggle = this.querySelector('.products-tabs-grid__sort-toggle');
            this.sortMenu = this.querySelector('.products-tabs-grid__sort-menu');
            this.sortItems = Array.from(this.querySelectorAll('.products-tabs-grid__sort-item'));

            const activeTab = this.querySelector('.products-tabs-grid__tab.is-active');
            this.currentTab = activeTab?.dataset.tab || this.tabs[0]?.dataset.tab || 'all';

            this.currentSort = 'manual';

            this.onDocumentClick = this.onDocumentClick.bind(this);
        }

        connectedCallback() {
            this.init();
        }

        disconnectedCallback() {
            document.removeEventListener('click', this.onDocumentClick);
        }

        init() {
            if (!this.grid || !this.tabs.length || !this.items.length) return;

            this.tabs.forEach((tab) => {
                tab.addEventListener('click', () => this.onTabClick(tab));
            });

            this.sortItems.forEach((item) => {
                item.addEventListener('click', () => this.onSortClick(item));
            });

            if (this.sortToggle && this.sortMenu) {
                this.sortToggle.addEventListener('click', () => this.toggleSortMenu());
                document.addEventListener('click', this.onDocumentClick);
            }

            this.syncActiveTabState();
            this.applyFilter();
            this.applySort();
        }

        syncActiveTabState() {
            this.tabs.forEach((button) => {
                const isActive = button.dataset.tab === this.currentTab;
                button.classList.toggle('is-active', isActive);
                button.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });
        }

        onTabClick(tab) {
            this.currentTab = tab.dataset.tab || 'all';

            this.syncActiveTabState();
            this.applyFilter();
            this.applySort();
        }

        onSortClick(button) {
            this.currentSort = button.dataset.sort || 'manual';

            this.sortItems.forEach((item) => {
                item.classList.remove('is-active');
            });

            button.classList.add('is-active');

            this.applySort();
            this.closeSortMenu();
        }

        toggleSortMenu() {
            const isExpanded = this.sortToggle.getAttribute('aria-expanded') === 'true';

            this.sortToggle.setAttribute('aria-expanded', String(!isExpanded));
            this.sortMenu.hidden = isExpanded;
        }

        closeSortMenu() {
            if (!this.sortToggle || !this.sortMenu) return;

            this.sortToggle.setAttribute('aria-expanded', 'false');
            this.sortMenu.hidden = true;
        }

        onDocumentClick(event) {
            if (!this.contains(event.target)) {
                this.closeSortMenu();
            }
        }

        applyFilter() {
            this.items.forEach((item) => {
                const tabsValue = item.dataset.tabs || '';
                const itemTabs = tabsValue
                    .split(',')
                    .map((value) => value.trim())
                    .filter(Boolean);

                item.hidden = !itemTabs.includes(this.currentTab);
            });
        }

        applySort() {
            const visibleItems = this.items.filter((item) => !item.hidden);

            visibleItems.sort((a, b) => {
                const aPrice = Number(a.dataset.price || 0);
                const bPrice = Number(b.dataset.price || 0);

                const aTitle = (a.dataset.title || '').toLowerCase();
                const bTitle = (b.dataset.title || '').toLowerCase();

                const aPosition = Number(a.dataset.position || 0);
                const bPosition = Number(b.dataset.position || 0);

                switch (this.currentSort) {
                    case 'price-asc':
                        return aPrice - bPrice;

                    case 'price-desc':
                        return bPrice - aPrice;

                    case 'title-asc':
                        return aTitle.localeCompare(bTitle);

                    case 'title-desc':
                        return bTitle.localeCompare(aTitle);

                    default:
                        return aPosition - bPosition;
                }
            });

            visibleItems.forEach((item) => {
                this.grid.appendChild(item);
            });
        }
    }

    customElements.define('products-tabs-grid', ProductsTabsGrid);
}